/**
 * Uplifted pieces of `helper/discountValidationFlow` (apps/web + apps/mobile) — WEB half.
 *
 * Seeded with the single symbol `utils/apiService`'s response interceptor needs. The rest of
 * that file (`handleDiscountApproval`, `checkAndUpdateApprovalState`, the discount-limit
 * checks) stays in the apps — it reaches into `facade/ServiceFacade`, `SaleSlice` and
 * `featureRestrictionHelper`, none of which are in core yet.
 *
 * 🔴 `shared.ts` holds no code: the two bodies differ in the payload key they build (see below).
 * It still exists (standing rule 4) and records why collapsing them would silently FIX a
 * pre-existing app bug — which is a decision, not an uplift.
 */
import store from "../../redux-store";
import {
  addDiscountApprovalData,
  setShowDiscountStatusModal,
} from "../../redux-store/slices/DiscountSlice";
import { addNcApprovalData } from "../../redux-store/slices/NcApprovalSlice";

export * from "./shared";   // rule 4: the folder always has all three files

/**
 * Opens the "approval requested" modal after the backend answers `REST_NEED_ORDER_APPROVAL`.
 *
 * ⚠️ **Divergent from mobile in the payload key, and the difference is preserved verbatim.**
 * Web takes `discountTotal`; mobile's signature takes `totalDiscount` while BOTH apps'
 * interceptors call it with `{ mid, discountTotal }` — so on mobile the field lands as
 * `undefined`. That is a pre-existing app bug, not something this uplift introduces or fixes;
 * unifying the two here would silently change mobile's stored approval data. See
 * `index.native.ts`.
 *
 * The two `store.dispatch` calls go through the STORE BRIDGE — an interceptor has no caller to
 * pass state to, which is the reason the bridge exists (ledger, "The two bridges").
 */
export function showApprovalRequestModal({ mid, discountTotal, type }: { mid: string; discountTotal: number, type: string }) {
  if (type === "APPROVE_NON_CHARGEABLE_SALE") {
    store.dispatch(addNcApprovalData({
      isApprovalRequired: true,
      isApproved: false,
      isRequested: false,
      requestType: "APPROVE_NON_CHARGEABLE_SALE",
      mid,
    }))
  } else {
    store.dispatch(addDiscountApprovalData({ isApprovalRequired: true, isApproved: false, isRequested: false, mid, discountTotal }));
  }
  store.dispatch(setShowDiscountStatusModal({ showStatusModal: true, isRequestPending: true }));
}
